import { TemplateQueryResponse } from '@common/types';
import { templatesPath } from '@components/Hooks/useRouter';
import { useTemplatesBi } from '@components/Hooks/useTemplatesBi';
import { updateQueryParams } from '@utils/route';
import { useRouter } from 'next/router';
import { useCallback } from 'react';

export const useTemplatesPaginationFooter = ({
  queryData,
}: {
  queryData?: TemplateQueryResponse;
}) => {
  const router = useRouter();

  const { logBiClick } = useTemplatesBi({
    is_mobile: false,
  });

  const onPageClicked = useCallback(
    (page: number) => {
      logBiClick({
        click_type: 'Next page',
        click_data: { page_number: page },
      });
    },
    [logBiClick],
  );

  const getPageUrl = useCallback(
    (page: number) => `${templatesPath}${updateQueryParams({ page }, router)}`,
    [router, templatesPath],
  );

  const moreThanOnePage =
    queryData?.numberOfPages && queryData?.numberOfPages > 1;

  return {
    onPageClicked,
    getPageUrl,
    moreThanOnePage,
  };
};
